import * as React from "react";

const AcornsLogo = () => (
  <svg
    width="24"
    height="28"
    viewBox="0 0 24 28"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="AcornsSplashWeb" fill="none" fillRule="evenodd">
      <g
        id="1---Banner---Desktop-Copy-9"
        transform="translate(-1000 -702)"
        fill="#4BC459"
      >
        <g id="Group-3" transform="translate(1000 702)">
          <path d="M22.2900035,13.6175115 L1.01164547,13.6194684 C-0.864095004,13.4785726 -0.803324618,4.6927164 10.083879,3.93875641 C10.187683,3.89262983 10.2097813,3.88200674 10.2702609,3.6919093 C10.3711572,3.33966993 10.4290199,2.99637633 10.438906,2.67209246 C10.4502459,2.27484473 10.3950001,1.92148714 10.2717147,1.59105307 C10.1606416,1.29779982 9.99170574,1.01908343 9.77159483,0.769999874 C10.1071404,0.770838539 10.438906,0.835136201 10.760204,0.962054196 C11.1730937,1.12056191 11.591508,1.3936872 11.9683425,1.75431322 C12.3184265,2.08614507 12.641469,2.4914999 12.9302011,2.95975461 C13.0683156,3.18423732 13.192764,3.41179514 13.3108156,3.65640581 C13.3666429,3.77521671 13.4207257,3.89850049 13.4719007,4.02765492 C24.0988675,4.90937156 24.1514964,13.4771749 22.2900035,13.6175115" />
          <path d="M21.7887206,14.543957 C21.7887206,14.543957 23.4713915,24.6104549 13.167758,26.5119884 C12.7004948,26.8949788 11.9247274,27.7738999 11.6421015,27.7699861 C11.3591848,27.7738999 10.5834174,26.8949788 10.1155727,26.5119884 C-0.245341985,24.8044661 1.49373781,14.543957 1.49373781,14.543957 L21.7887206,14.543957" />
        </g>
      </g>
    </g>
  </svg>
);

export default AcornsLogo;



// WEBPACK FOOTER //
// ./src/pages/Acorns/AcornsLogo.tsx